<!--
	ServiceUpdatePage.svelte

    Here we are updating the masterUpdateService object

    WE NEED TO LOAD IN CASE THE USER REFRESHED THE BROWSER

    TODO: renable isFormValid check for SUBMIT UPDATE button
-->

<script>
    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';
    import { pop, push } from 'svelte-spa-router';
    import { fetchServiceById2, requestUpdateService2} from '../../api/services.ts';

    import { SERVICE_NAME, DESCRIPTION } from '../../common/constants.js';
	import { setWarningAlert, setErrorAlert, setInfoAlert, PENDING_MSECS } from '../../stores/AlertsStore';
    import {AccountStore} from "../../common/account";

    // 5/12 - the master service objects (stores)
	import { masterService, masterUpdateService } from '../../common/master-objects.js';

    // new 09/01 - for populating API-aware fields
    import {fetchAllFieldsPresets} from "../../stores/FieldPresetsStore";

    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';
    import ServiceUpdateFields from '../../components/services/ServiceUpdateFields.svelte';
    import CircularSpinner from '../../components/common/CircularSpinner.svelte';

    // SMUI components
    import Button, { Label, Icon } from '@smui/button';
	import { Svg } from '@smui/common/elements';
	import { mdiArrowLeftTop, mdiCheck } from '@mdi/js';

    export let params = {}				                // must define the route component prop "params"
    let data = null;

    $: isFetchingData = false;

    const SUBMIT_PENDING_MSG  = 'Submitting your new service for review - click to cancel';
    const SUBMIT_ERROR_MSG = 'Error while submitting your new service.';
    const SUBMIT_SUCCESS_MSG = 'Successfully submitted your new service for review.';
    const CANCEL_INFO_MSG  = 'Your updates have been cancelled.';
    const FETCH_ERROR_MSG  = 'Error while fetching this service.';
    const FORM_INVALID_MSG  = 'Please enter the service Name and Description.';
    
    // does the service need to load again?
    onMount(async () => {
        // console.log('');
        // console.log('ServiceUpdatePage onMount');
        // console.log('calling fetchAllFieldsPresets');


        if (!$AccountStore?.isLoggedIn) {
            push('/');                                  // and login
        }

        fetchAllFieldsPresets();                        // populate the fieldPresetsStore
        isFetchingData = true;
        data = await fetchServiceById2(params.id);
        isFetchingData = false;

        if (data.errors) {
            setErrorAlert(FETCH_ERROR_MSG, 2000);
        } else {
            // console.log('ServiceUpdatePage onMount - fetched Service OK:');
            // console.log(data);
            $masterService.clearApiData();
            $masterService.copyApiDataFrom(data);
            $masterService = $masterService;                // refresh the store

            $masterUpdateService.clearApiData();
            $masterUpdateService.copyApiDataFrom($masterService.apiData);
            $masterUpdateService = $masterUpdateService;    // refresh the store

            // console.log('ServiceUpdatePage onMount - initialized masterService and masterUpdateService objects');
        }

        scrollTo(0, 0);
    })

    const getIsFormValid = (serviceApiData) => {
        let isValid = (serviceApiData[SERVICE_NAME] !== '') && (serviceApiData[DESCRIPTION] !== '');
        return isValid;
    }

    // include the callback for after the message completes
    // POST /intake/upsert-service
    const submitUpdates = () => {
        // console.log('');
        // console.log('ServiceUpdatePage submitUpdates');

        if (!getIsFormValid($masterUpdateService.apiData)) {
            setWarningAlert(FORM_INVALID_MSG, 2000);
            return;
        }

        delete $masterUpdateService.apiData.id;         // DO NOT COPY THE ID!
        $masterUpdateService.flattenTaxonomiesNodesToApiData();
        const body = {
            "leftServiceIds": [$masterService.apiData.id],
            "rightService": $masterUpdateService.apiData
        }
        body.rightService.source = $AccountStore.username;     // source is the user?

        // console.log(body);
        // passing in the function - will not run if Alert is cancelled
        setInfoAlert(SUBMIT_PENDING_MSG, PENDING_MSECS, async () => {
            let json = await requestUpdateService2(body);
            if (json.errors) {
                setErrorAlert(SUBMIT_ERROR_MSG, 2000);
            } else {
                setInfoAlert(SUBMIT_SUCCESS_MSG, 2000);
                pop();
            }
        });
    }

    // data will get reset again on next load
    const cancelUpdates = () => {
        $masterUpdateService.copyApiDataFrom($masterService.apiData);
        $masterUpdateService = $masterUpdateService;                    // Svelte retrigger
        // setInfoAlert(CANCEL_INFO_MSG, 1000, () => pop());
        pop();          // no alert message for Cancel
    }

</script>

<style>

    :global(.update-service .mdc-button) {
        /* text-transform: none; */
        border-radius: 18px;
        overflow: hidden;
    }

    :global(.bottom-buttons .mdc-button) {
        background-color: var(--tcare-purple) !important;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="page-content update-service" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">
    <!-- {#if $masterService.apiData && $masterUpdateService.apiData} -->
    {#if isFetchingData}
        <div class="spinner-wrapper">
            <CircularSpinner delay={500} label={'Fetching service details'}  />
        </div>
    {:else if data}
    
        <div class="spacer-h-25"></div>
        <PageBanner title={"Update Service: " + $masterUpdateService.apiData.serviceName}/>
        <div class="spacer-h-25"></div>

        <!-- TODO: THIS SHOULD BE A SUBMIT PANEL {#if isFormValid} -->
        <div class="flex-row top-buttons">
            <Button on:click={() => cancelUpdates()} variant="outlined" >
                <Label>Cancel and Return</Label>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowLeftTop} /></Icon>
            </Button>
            <Button on:click={() => submitUpdates()} variant="outlined" >
                <Label>Submit Updates</Label>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCheck} /></Icon>
            </Button>
        </div>

        <div class="spacer-h-20"></div>
        <ServiceUpdateFields store={masterUpdateService} />

        <div class="spacer-h-50"></div>

        <div class="flex-row jc-center bottom-buttons">
            <Button on:click={() => submitUpdates()} variant="raised" >
                <Label>Submit Updates</Label>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowLeftTop} /></Icon>
            </Button>
        </div>

        <div class="spacer-h-50"></div>

    {/if}
</div>
